import _ from "lodash";

import maintenance from "./json/fake/maintenance";
import axios from "axios";
import BaseApi from "./baseApi";

export default class MaintenanceApi extends BaseApi {
  constructor(organizationCode) {
    super(organizationCode);
  }

  getSpareParts(spareId) {
    return axios.get(this.url + "/api/integrations/eshop/products/" + spareId).then(response => {
      return response;
    });
  }
  addShoppingCart(ar_products, o_code, o_email) {
    const params = {
      products: !!ar_products && ar_products.length > 0 ? ar_products : [],
      OrganizationEmail: o_email,
      OrganizationCode: o_code //"scm"
    };
    // FAKE DATA
    params.OrganizationEmail = "maestroconnect@scmgroup.com";
    params.OrganizationCode = "scm";

    return axios.post(this.url + "/api/integrations/eshop/cart", params).then(response => {
      return response;
    });
  }

  getFakeMaintenance(find = "") {
    const p = new Promise(resolved => {
      let res = maintenance;
      switch (find) {
        case "todo":
          res = _.filter(maintenance, function (item) {
            return item.priority >= 0 && !item.id_assegne;
          });
          break;
        case "todo-assigned":
          res = _.filter(maintenance, function (item) {
            return item.priority >= 0 && !!item.id_assegne;
          });
          break;
        case "done":
          res = _.filter(maintenance, function (item) {
            return item.priority === -1;
          });
          break;
        default:
          break;
      }
      resolved(res);
    });
    return p;
  }

  /* ADD TASK */
  addTask = async task => {
    // ADD OPERATION
    const tryAddMachinesOperations = async (machine_id, obj_operation) => {
      const res = await axios.post(
        `${this.url}/api/${this.organizationCode}/machines/${machine_id}/operations`,
        obj_operation
      );
      return res.data.result;
    };

    const add_maintenance = await axios.post(
      `${this.url}/api/${this.organizationCode}/maintenances`,
      {
        action: task.maintenance.action,
        group: task.maintenance.group,
        device: task.maintenance.device,
        counters: task.maintenance.counters.reduce((acc, counter) => {
          return [
            ...acc,
            {
              unit: counter.unit.toUpperCase(),
              name: "TIME",
              triggers: [
                {
                  value: counter.triggers[0].value.toString()
                }
              ]
            }
          ];
        }, [])
      }
    );

    task.maintenance.code = add_maintenance.data.result.code;

    const machine_operations = task.operations.filter(el => el.selected === true);
    const add_operations = await Promise.all(
      machine_operations.map(async mop => {
        const obj_operation = _operationFactory(task.maintenance.code, mop);
        return tryAddMachinesOperations(mop.machine_Id, obj_operation);
      })
    );
    const result_add = await Promise.all([add_maintenance.data.result, add_operations]);
    return result_add;
  };

  /* EDIT TASK */
  updateTask = async task => {
    // ADD OPERATION
    const addMachinesOperations = (machine_id, obj_operation) => {
      return axios
        .post(
          `${this.url}/api/${this.organizationCode}/machines/${machine_id}/operations`,
          obj_operation
        )
        .then(response => {
          if (response && response.data && response.data.result) {
            return response.data.result;
          } else {
            return null;
          }
        });
    };
    // DELETE
    const deleteMachineOperations = (machine_id, operation_id) => {
      return axios.delete(
        `${this.url}/api/${this.organizationCode}/machines/${machine_id}/operations/${operation_id}`
      );
    };
    // UPDATE MAINTENANCE
    const updateMaintenance = (id, maintenanceValue) => {
      return axios
        .patch(this.url + "/api/" + this.organizationCode + "/maintenances/" + id, maintenanceValue)
        .then(() => {});
    };

    const upd_maintenance = updateMaintenance(task.maintenance.id, {
      action: task.maintenance.action,
      group: task.maintenance.group,
      device: task.maintenance.device,
      counters: task.maintenance.counters.reduce((acc, counter) => {
        return [
          ...acc,
          {
            unit: counter.unit.toUpperCase(),
            name: "TIME",
            triggers: [
              {
                value: counter.triggers[0].value.toString()
              }
            ]
          }
        ];
      }, [])
    });

    const upd_machine_operations = Promise.all(
      task.operations.map(async mop => {
        // Delete operation
        if (mop.operation_Id && mop.selected === false) {
          return deleteMachineOperations(mop.machine_Id, mop.operation_Id);
        }
        // Add operation
        else if (!mop.operation_Id && mop.selected === true) {
          return addMachinesOperations(
            mop.machine_Id,
            _operationFactory(task.maintenance.code, mop)
          );
        }
      })
    );

    return await Promise.all([upd_maintenance, upd_machine_operations]);
  };
  // end EDIT TASK

  /* DELETE TASK */
  deleteTask = async task => {
    // DELETE OPERATIONS
    const deleteMachineOperations = (machine_id, operation_id) => {
      return axios.delete(
        `${this.url}/api/${this.organizationCode}/machines/${machine_id}/operations/${operation_id}`
      );
    };
    // DELETE MAINTENANCE
    const deleteMaintenance = id => {
      return axios
        .delete(this.url + "/api/" + this.organizationCode + "/maintenances/" + id)
        .then(() => {});
    };

    const del_machine_operations = Promise.all(
      task.operations.map(async mop => {
        // Delete operation
        return deleteMachineOperations(mop.operation.machineId, mop.operation.uuid);
      })
    );

    const del_maintenance = deleteMaintenance(task.maintenance.uuid);

    return await Promise.all([del_maintenance, del_machine_operations]);
  };
  // end DELETE TASK

  /**
   * Get all organization mainentances
   * Data Params:
   * @param {string} machineids machine Ids, separate by comma "id1,id2"
   * @param {number} limit limit
   * @param {number} skip skip
   * @param {string} sort sort
   * @returns {Array} maintenances
   */
  getAllMaintenance(search) {
    return axios
      .get(this.url + "/api/" + this.organizationCode + "/maintenances", { params: search })
      .then(response => {
        return response.data;
      });
  }
  getMaintenanceById(id) {
    return axios
      .get(this.url + "/api/" + this.organizationCode + "/maintenances/" + id)
      .then(response => {
        return response.data.result;
      });
  }

  deleteMaintenance(id) {
    return axios.delete(this.url + "/api/" + this.organizationCode + "/maintenances/" + id);
  }

  getMachinesOperations(search, machine_id) {
    return axios
      .get(this.url + "/api/" + this.organizationCode + "/machines/" + machine_id + "/operations", {
        params: search
      })
      .then(response => {
        return response.data;
      });
  }

  getGroupMaintenanceActivities(group_id, search) {
    const queryStr = {
      skip: 0,
      limit: 1000
    };
    Object.assign(queryStr, search);

    return axios
      .get(`${this.url}/api/${this.organizationCode}/machinegroups/${group_id}/activities`, {
        params: queryStr
      })
      .then(response => {
        return response.data.result;
      });
  }

  saveAssignment(group_id, activity_id, userId) {
    return axios.patch(
      `${this.url}/api/${this.organizationCode}/machinegroups/${group_id}/activities/${activity_id}`,
      { assignee: userId }
    );
  }

  /*
   * *****************
   * *** ACTIVITES ***
   * *****************
   */

  /**
   * Save status activity as done
   * Data Params:
   * @param {string} activity_id id activity
   */
  async saveActivityStatusDone(activity_id) {
    return axios
      .patch(`${this.url}/api/${this.organizationCode}/activities/${activity_id}/status/done`)
      .then(() => {
        return true;
      });
  }

  /**
   * Set activity as assigned
   * Data Params:
   * @param {string} activity_id id activity
   * @param {string} user_id id user
   */
  async saveAssignedActivity(activity_id, user_id) {
    return axios
      .patch(`${this.url}/api/${this.organizationCode}/activities/${activity_id}`, {
        AssigneeId: user_id
      })
      .then(() => {
        return true;
      });
  }

  /**
   * Get machines activities
   * Default sort by Timestamp desc
   * Params:
   * @param {string} machineids machine Id, separate BY COMMA "id1,id2"
   * @param {integer} minpriority priority >=
   * @param {integer} maxpriority priority <=
   * @param {integer} priority priority =
   * @returns {Array} promise with activities
   */
  async getActivitiesByMachines(search) {
    const params = {
      params: {
        ...search
      }
    };
    return axios
      .get(`${this.url}/api/${this.organizationCode}/activities`, params)
      .then(response => {
        return response.data;
      });
  }

  /**
   * Get activity by Id
   * Params
   * @param {string} id
   * @returns {Object} activity
   */
  async getActivitiyById(id) {
    return axios.get(`${this.url}/api/${this.organizationCode}/activities/${id}`).then(response => {
      return response.data.result;
    });
  }

  /**
   * Gets activities assegned to current user (me)
   * @param {string} userId
   * @returns {Array} activities
   */
  async getActivitiesAssignedMe(userId) {
    return axios
      .get(`${this.url}/api/${this.organizationCode}/users/${userId}/activities`)
      .then(response => {
        return response.data;
      });
  }

  /**
   * Get machines history activities
   * Params:
   * @param {string} machineids machine Id, separate BY COMMA "id1,id2"
   * @param {string} from ISO date
   * @param {string} to ISO date
   * @param {integer} skip
   * @param {integer} limit
   * @param {string} sort
   * @returns {Array} promise with activities
   */
  async getActivitiesHistoryByMachines(search) {
    return axios
      .get(`${this.url}/api/${this.organizationCode}/activities/history`, {
        params: search
      })
      .then(response => {
        return response.data;
      });
  }

  getMachineDocuments(machineSerial) {
    return axios
      .get(
        `${this.url}/api/${this.organizationCode}/machines/${encodeURIComponent(
          machineSerial
        )}/documents`
      )
      .then(response => {
        return response.data;
      });
  }

  getMachineDocumentDetails(machineSerial, documentId) {
    return axios
      .get(
        `${this.url}/api/${this.organizationCode}/machines/${encodeURIComponent(
          machineSerial
        )}/documents/${documentId}`,

        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        return response.data;
      });
  }
}

function _operationFactory(maintenanceCode, mop) {
  return {
    code: maintenanceCode,
    expert: mop.expert || true,
    model: mop.model || "",
    location: mop.location || ""
  };
}
